import BlockFormatPluginFactory from '../Blocks/BlockFormatPluginFactory';
import ParagraphNormalizationsPlugin from './ParagraphNormalizationsPlugin';

const ParagraphPlugin = [
  BlockFormatPluginFactory({
    type: 'paragraph',
    title: 'Paragraph',
    tag: 'p',
  }),
  ParagraphNormalizationsPlugin,
];

export default ParagraphPlugin;
